export default __webpack_public_path__ + "static/media/logo.ac0246a6.svg";